import api from './api'

const activityLogsService = {
  getLogs: async (params = {}) => {
    const { data } = await api.get('/admin/activity-logs', { params })
    return data
  },

  getDistinctActions: async () => {
    const { data } = await api.get('/admin/activity-logs/actions')
    return data.data
  },

  getStats: async (hours = 24) => {
    const { data } = await api.get('/admin/activity-logs/stats', { params: { hours } })
    return data.data
  },

  createEventSource: () => {
    const baseUrl = api.defaults?.baseURL || '/api/v1'
    const token = document.cookie
      .split('; ')
      .find(row => row.startsWith('accessToken='))
      ?.split('=')[1]

    const url = `${baseUrl}/admin/activity-logs/stream${token ? `?token=${token}` : ''}`
    return new EventSource(url)
  },

  exportCsv: async (params = {}) => {
    const { data } = await activityLogsService.getLogs({ ...params, limit: 10000 })
    const logs = data?.logs || []

    if (logs.length === 0) return null

    const headers = ['التاريخ', 'الإجراء', 'الدور', 'الفئة', 'المستخدم', 'الكيان', 'التفاصيل', 'IP']
    const rows = logs.map(log => [
      new Date(log.createdAt).toLocaleString('ar-EG'),
      log.action,
      log.role,
      log.category,
      log.user?.name || '—',
      log.entityType ? `${log.entityType}: ${log.entityLabel || log.entityId || ''}` : '—',
      log.metadata ? JSON.stringify(log.metadata) : '—',
      log.ipAddress || '—',
    ])

    const csvContent = [headers, ...rows]
      .map(row => row.map(cell => `"${String(cell).replace(/"/g, '""')}"`).join(','))
      .join('\n')

    const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' })
    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.download = `activity-logs-${new Date().toISOString().slice(0, 10)}.csv`
    link.click()
    URL.revokeObjectURL(link.href)

    return logs.length
  },
}

export default activityLogsService
